(function () {
  'use strict';

  function initProduct(root) {
    if (!root || root.dataset.aliInitialized === 'true') return;
    root.dataset.aliInitialized = 'true';

    var variantsNode = root.querySelector('[data-ali-variants]');
    var variants = [];
    try { variants = JSON.parse(variantsNode ? variantsNode.textContent : '[]'); } catch (error) { variants = []; }

    var form = root.querySelector('[data-ali-product-form]');
    var variantSelect = root.querySelector('[data-ali-variant-select]');
    var optionInputs = Array.prototype.slice.call(root.querySelectorAll('[data-ali-option-input]'));
    var addButton = root.querySelector('[data-ali-add-to-cart]');
    var buyNow = root.querySelector('[data-ali-buy-now]');
    var addLabel = root.querySelector('[data-ali-add-label]');
    var price = root.querySelector('[data-ali-price]');
    var comparePrice = root.querySelector('[data-ali-compare-price]');
    var priceBadge = root.querySelector('[data-ali-price-badge]');
    var saleBadge = root.querySelector('[data-ali-sale-badge]');
    var buttonPrice = root.querySelector('[data-ali-button-price]');
    var stock = root.querySelector('[data-ali-stock]');
    var stockText = root.querySelector('[data-ali-stock-text]');
    var mobilePrice = root.querySelector('[data-ali-mobile-price]');
    var mobileAdd = root.querySelector('[data-ali-mobile-add]');

    function selectedOptions() {
      var fieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-ali-option-index]'));
      return fieldsets.map(function (fieldset) {
        var selected = fieldset.querySelector('[data-ali-option-input]:checked');
        return {
          index: Number(fieldset.dataset.aliOptionIndex),
          value: selected ? selected.value : ''
        };
      }).filter(function (selection) { return selection.value !== ''; });
    }

    function currentVariant() {
      var options = selectedOptions();
      if (!options.length && variantSelect) {
        return variants.find(function (variant) { return String(variant.id) === String(variantSelect.value); });
      }
      return variants.find(function (variant) {
        return options.every(function (selection) {
          return variant.options[selection.index] === selection.value;
        });
      });
    }

    function showMedia(mediaId) {
      if (!mediaId) return;
      var target = root.querySelector('[data-ali-media-id="' + mediaId + '"]');
      if (!target) return;
      root.querySelectorAll('[data-ali-media-id]').forEach(function (slide) {
        var active = slide === target;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
        if (!active) {
          slide.querySelectorAll('video').forEach(function (video) { video.pause(); });
        }
      });
      root.querySelectorAll('[data-ali-gallery-thumb]').forEach(function (thumb) {
        var active = String(thumb.dataset.aliGalleryThumb) === String(mediaId);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
        if (active) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
    }

    function updateOptionLabels() {
      root.querySelectorAll('[data-ali-option-index]').forEach(function (fieldset) {
        var selected = fieldset.querySelector('[data-ali-option-input]:checked');
        var label = fieldset.querySelector('[data-ali-option-label]');
        if (selected && label) label.textContent = selected.value;
      });
    }

    function updateVariant() {
      var variant = currentVariant();
      updateOptionLabels();

      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (buyNow) buyNow.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        if (mobileAdd) { mobileAdd.disabled = true; mobileAdd.textContent = 'Unavailable'; }
        if (stock) stock.classList.add('is-sold-out');
        if (stockText) stockText.textContent = 'Combination unavailable';
        return;
      }

      if (variantSelect) variantSelect.value = variant.id;
      if (price) price.textContent = variant.priceFormatted;
      if (buttonPrice) buttonPrice.textContent = variant.priceFormatted;
      if (mobilePrice) mobilePrice.textContent = variant.priceFormatted;

      var onSale = variant.compareAtPrice > variant.price;
      var saving = onSale ? Math.round(((variant.compareAtPrice - variant.price) / variant.compareAtPrice) * 100) : 0;
      if (comparePrice) {
        comparePrice.hidden = !onSale;
        comparePrice.textContent = variant.compareAtFormatted;
      }
      if (priceBadge) {
        priceBadge.hidden = !onSale;
        priceBadge.textContent = 'Save ' + saving + '%';
      }
      if (saleBadge) {
        saleBadge.hidden = !onSale;
        saleBadge.textContent = '-' + saving + '%';
      }

      if (stock) stock.classList.toggle('is-sold-out', !variant.available);
      if (stockText) stockText.textContent = variant.available ? 'In stock and ready to ship' : 'Currently out of stock';
      if (addButton) addButton.disabled = !variant.available;
      if (buyNow) buyNow.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (mobileAdd) {
        mobileAdd.disabled = !variant.available;
        mobileAdd.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }

      if (variant.featuredMediaId) showMedia(variant.featuredMediaId);

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      root.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: variant } }));
    }

    optionInputs.forEach(function (input) { input.addEventListener('change', updateVariant); });

    var quantity = root.querySelector('[data-ali-quantity] input');
    var minus = root.querySelector('[data-ali-quantity-minus]');
    var plus = root.querySelector('[data-ali-quantity-plus]');
    if (quantity && minus) minus.addEventListener('click', function () { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
    if (quantity && plus) plus.addEventListener('click', function () { quantity.value = Math.max(1, Number(quantity.value || 1) + 1); });

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ali-gallery-thumb]'));
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { showMedia(thumb.dataset.aliGalleryThumb); });
    });

    function moveGallery(direction) {
      if (!thumbs.length) return;
      var currentIndex = thumbs.findIndex(function (thumb) { return thumb.classList.contains('is-active'); });
      var nextIndex = (currentIndex + direction + thumbs.length) % thumbs.length;
      showMedia(thumbs[nextIndex].dataset.aliGalleryThumb);
    }
    var previous = root.querySelector('[data-ali-gallery-prev]');
    var next = root.querySelector('[data-ali-gallery-next]');
    if (previous) previous.addEventListener('click', function () { moveGallery(-1); });
    if (next) next.addEventListener('click', function () { moveGallery(1); });

    var share = root.querySelector('[data-ali-share]');
    var shareStatus = root.querySelector('[data-ali-share-status]');
    if (share) {
      share.addEventListener('click', function () {
        var shareData = { title: document.title, url: share.dataset.shareUrl || window.location.href };
        if (navigator.share) {
          navigator.share(shareData).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(shareData.url).then(function () {
            if (shareStatus) shareStatus.textContent = 'Link copied';
            window.setTimeout(function () { if (shareStatus) shareStatus.textContent = ''; }, 2000);
          });
        }
      });
    }

    var mobileBar = root.querySelector('[data-ali-mobile-buybar]');
    if (mobileBar && addButton) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { mobileBar.classList.toggle('is-visible', !entry.isIntersecting); });
      }, { threshold: 0 });
      observer.observe(addButton);
    }
    if (mobileAdd && form) {
      mobileAdd.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(addButton);
        else addButton.click();
      });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ali-product-root]').forEach(initProduct);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
